import React, { useRef, forwardRef, useState, useEffect } from 'react';
import { FaUpload, FaCloud } from 'react-icons/fa';
import '../InputFile/InputFile.scss';
import Modal from './../Modal';
import useModal from '../../customHooks/useModal';
import S3Item from '../InputFile/S3Item';
import Button from '../Button';
import translations from '../../translations/de';
import API from '../../api/users';
import ItemImage from '../ItemImage';

const InputJersey = forwardRef(
    (
        {
            value,
            label = '',
            error = false,
            resetValue,
            disabled,
            pathToCloudFolder,
            readOnly,
            centerLabel = false, // if I want input label centered
            preferredFileSize = translations.imageLabelSvg,
            ...restProps
        },
        ref,
    ) => {
        const inputFileRef = useRef();
        const modalRef = useRef(null);
        const [modal, setModal] = useModal(false, modalRef);
        const [uploads, setUploads] = useState(null);
        const [loading, setLoading] = useState(false);
        const [localValue, setLocalValue] = useState(null);

        const handleUpload = () => {
            if (inputFileRef.current.files[0]) {
                const formData = new FormData();
                formData.append('file', inputFileRef.current.files[0]);

                API.uploadFile(formData, pathToCloudFolder)
                    .then((res) => {
                        resetValue(res.data.imageUrl);
                        setLocalValue(res.data.imageUrl);
                        setLoading(false);
                    })
                    .catch((e) => {
                        console.log(e);
                        setLoading(false);
                    });
            }
        };

        const getFromCloud = () => {
            API.getFiles(pathToCloudFolder)
                .then((res) => {
                    console.log(res);

                    setUploads(res.data);
                    setModal(true);
                })
                .catch((e) => console.log('error', e));
        };

        useEffect(() => {
            setLocalValue(value);
        }, [value]);

        return (
            <>
                <div className="Input">
                    <div style={{ marginTop: '50px' }}></div>
                    {label && (
                        <div className={`${centerLabel ? 'centered-label' : 'label'}`}>
                            <span>{label} </span>
                        </div>
                    )}
                    <ItemImage imgSrc={localValue} />

                    <div className="Input-File">
                        <input
                            ref={ref}
                            disabled={disabled}
                            readOnly={readOnly}
                            type="text"
                            {...restProps}
                        />

                        <input
                            ref={inputFileRef}
                            type="file"
                            accept=".svg,image/svg+xml"
                            style={{ display: 'none' }}
                            onChange={handleUpload}
                        />
                        {!disabled && !readOnly && (
                            <div className="Input-File-Controls">
                                <Button
                                    title="Upload Local Files"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        inputFileRef.current.click();
                                    }}
                                    disabled={disabled}
                                    loading={loading}
                                >
                                    <FaUpload />
                                </Button>
                                <Button
                                    title="Uploaded On Cloud"
                                    disabled={disabled}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        getFromCloud();
                                    }}
                                >
                                    <FaCloud />
                                </Button>
                            </div>
                        )}
                    </div>
                    {!disabled && preferredFileSize && (
                        <div className="preferred-format">{preferredFileSize}</div>
                    )}

                    <span className="error-msg">{error && <p>{translations.required}</p>}</span>
                </div>
                {modal && (
                    <Modal
                        title="AWS S3 uploads"
                        ref={modalRef}
                        onClose={() => setModal(false)}
                        // maxWidth="800px"
                    >
                        <div className="S3-Itmes">
                            {uploads &&
                                uploads.length !== 0 &&
                                uploads.map((item) =>
                                    item ? (
                                        <S3Item
                                            key={item}
                                            path={item}
                                            onClick={(source) => {
                                                resetValue(source);
                                                setLocalValue(source);
                                                setModal(false);
                                            }}
                                        />
                                    ) : null,
                                )}
                        </div>
                    </Modal>
                )}
            </>
        );
    },
);

export default InputJersey;
